/** Backend `uri_issue` array keys from check_uri_issue (khazesh). */
export const URI_ISSUE_LABELS: Record<string, string> = {
  repetitive: 'نشانی با فولدر تکراری',
  underscore: 'نشانی دارای آندرلاین',
  uppercase: 'نشانی با حروف بزرگ',
  multiple_slash: 'نشانی با چندین اسلش',
  whitespace: 'نشانی دارای اسپیس',
  query_parameters: 'نشانی با کوئری',
  over_limit: 'نشانی طولانی',
  many_paths: 'نشانی با فولدر زیاد'
};

export function normalizeUriIssueKey(raw: unknown): string {
  try {
    return decodeURIComponent(String(raw ?? '')).trim();
  } catch {
    return String(raw ?? '').trim();
  }
}

export function uriIssueLabel(key: string): string {
  return URI_ISSUE_LABELS[key] ?? key;
}
